
import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import SchedulePicker from "@/components/SchedulePicker.vue";
import {formRules} from "@/utils/formRules";
import AddressGeo from "@/components/AddressGeo.vue";
import {Getter} from "vuex-class";
import debounce from "debounce";
export const DEBOUNCE_TIME_MILLI: number = 500;

const openingHoursFieldDayFn = () => ({
    isActive: true,
    continuous: {
        isActive: true,
        fromHours: "09:00",
        toHours: "18:00",
    },
    morning: {
        isActive: false,
        fromHours: "00:20",
        toHours: "00:00",
    },
    evening: {
        isActive: false,
        fromHours: "00:20",
        toHours: "00:00",
    },
});

@Component({
    components: { SchedulePicker, AddressGeo},
})
export default class RelayCreate extends Vue {

    get lang(): string {
        return this.$root.$i18n.locale;
    }

    get isFormComplete(): boolean {
        return this.valid &&
          this.companyId &&
          this.address.address &&
          this.address.zipcode &&
          this.address.city &&
          this.address.country &&
          this.address.latitude &&
          this.address.longitude;
    }

    get formattedCategoriesValues(): any[] {
        const lang: string = this.lang;
        return this.categories.map((category: any) => {
            return { text: category[lang], value: category.id };
        });
    }

    @Prop({default: false})
    public show: boolean;

    @Watch("searchCompany")
    public handlerSearch = debounce(this.getCompaniesByName, DEBOUNCE_TIME_MILLI);

    @Getter private isAdmin: boolean;
    @Getter private envCompany: any;

    private showDialog: boolean = false;
    private companyId: number | null = null;
    private companyAutoSelected: boolean = false;
    private showSchedule: boolean = false;
    private rules: object = formRules;
    private valid: boolean = true;
    private loading: boolean = false;
    private relay: any = {
        companyOpeningHours: {
            monday: openingHoursFieldDayFn(),
            tuesday: openingHoursFieldDayFn(),
            wednesday: openingHoursFieldDayFn(),
            thursday: openingHoursFieldDayFn(),
            friday: openingHoursFieldDayFn(),
            saturday: openingHoursFieldDayFn(),
            sunday: openingHoursFieldDayFn(),
        },
    };
    private address: any = {};
    private searchCompany: string = "";
    private categories: any[] = [];
    private companies: any[] = [];
    private isSearchingCategories: boolean = false;
    private isSearchingCompanies: boolean = false;

    @Watch("showDialog")
    public handlerShowDialog(newVal, oldVal) {
        if (newVal === false) {
            this.$emit("update:show", false);
            this.initRelay();
        } else {
            this.$emit("update:show", false);
        }
    }

    @Watch("show")
    public handlerShow(newVal, oldVal) {
        if (newVal === true) {
            this.showDialog = true;
        }
    }

    private mounted(): void {
        this.getCategories();
        if (!this.isAdmin && this.envCompany) {
            this.companyId = this.envCompany.id;
            this.companies = [this.envCompany];
            this.companyAutoSelected = true;
        }
    }

    private getCategories(): void {
        this.isSearchingCategories = true;
        this.$store.dispatch("categories/getAll")
            .then((res) => {
                this.categories = res.categories;
                this.isSearchingCategories = false;
            });
    }

    /**
     * Searches for companies by name and updates the component's state accordingly.
     *
     * @return {void}
     */
    private async getCompaniesByName(): Promise<void> {
      this.isSearchingCompanies = true;
      await this.$store.dispatch("admin/companies/searchByName", {
        search: this.searchCompany,
      }).then((res) => {
        this.companies = res.rows;
      })
        .finally(() => {
          this.isSearchingCompanies = false;
        });

    }

    private async createRelay(): Promise<void> {
        this.loading = true;
        this.$store.dispatch("relays/createRelay", {
            companyId: this.companyId,
            relay: this.relay,
            address: this.address,
        })
            .then((res) => {
                this.loading = false;
                this.showDialog = false;
                this.$emit("reset");
            })
            .catch((err) => {
                this.loading = false;
                this.$store.commit("alerts/displayError", {
                    msg : err,
                });
            });
    }

    private initRelay(): void {
        this.relay = {
            companyOpeningHours: {
                monday: openingHoursFieldDayFn(),
                tuesday: openingHoursFieldDayFn(),
                wednesday: openingHoursFieldDayFn(),
                thursday: openingHoursFieldDayFn(),
                friday: openingHoursFieldDayFn(),
                saturday: openingHoursFieldDayFn(),
                sunday: openingHoursFieldDayFn(),
            },
        };
        this.showSchedule = false;
    }
}
